import React, { useState, useEffect } from 'react';
import { AiOutlineSortAscending, AiOutlineSortDescending } from 'react-icons/ai';
import { useSortableData } from './SortableData';
import { get } from 'lodash';
import Pagination from './Pagination';

const DataTable = (props) => {
   const [currentPage, setCurrentPage] = useState(1);
   const { items, requestSort, sortConfig, setItems } = useSortableData(props.items);
   // let columnNames = props.columns.map((item) => item.columnName);
   const renderCell = (item, column) => {
      if (column.content) return column.content(item);
      return get(item, column.columnKey);
   };

   useEffect(() => {
      let data = [...props.items];
      let offset = 0 * props.pageSize;
      setItems(data.slice(offset, offset + props.pageSize));
   }, [props.items, props.pageSize, setItems]);

   const onPageChange = (page) => {
      let data = [...props.items];
      let offset = (page - 1) * props.pageSize;
      setCurrentPage(page);
      setItems(data.slice(offset, offset + props.pageSize));
   };

   const getIcons = (columnName) => {
      if (!sortConfig) {
         return <></>;
      } else {
         if (sortConfig.key === columnName) {
            return sortConfig.direction === 'ascending' ? (
               <span style={{ color: '#1f70ba', fontSize: '1.1em' }}>
                  <AiOutlineSortAscending />
               </span>
            ) : (
               <span style={{ color: '#1f70ba', fontSize: '1.1em' }}>
                  <AiOutlineSortDescending />
               </span>
            );
         }
      }
   };
   if (props.items.length <= 0) {
      return (
         <table className='table is-narrow is-fullwidth'>
            <thead>
               <tr className='is-size-7'>
                  {props.columns.map((item, index) => (
                     <td key={index} onClick={() => requestSort(item.columnKey)}>
                        {item.columnCaption.toUpperCase()} {getIcons(item.columnKey)}
                     </td>
                  ))}
               </tr>
            </thead>
            <tbody></tbody>
         </table>
      );
   } else {
      return (
         <>
            {/* style={{ 'overflow-x': 'auto' }} */}
            <table className='table is-striped is-narrow is-fullwidth'>
               <thead>
                  <tr className='is-size-7'>
                     {props.columns.map((item, index) => (
                        <td key={index} onClick={() => requestSort(item.columnKey)}>
                           {item.columnCaption.toUpperCase()} {getIcons(item.columnKey)}
                        </td>
                     ))}
                  </tr>
               </thead>
               <tbody>
                  {items.map((item, index) => {
                     return (
                        <tr
                           key={index}
                           className={props.fontClassName ? props.fontClassName : 'is-size-7'}
                        >
                           {props.columns.map((col, i) => (
                              <td key={i}>{renderCell(item, col)}</td>
                           ))}
                        </tr>
                     );
                  })}
               </tbody>
            </table>
            <Pagination
               itemsCount={props.items.length}
               pageSize={props.pageSize}
               currentPage={currentPage}
               onPageChange={onPageChange}
            />
         </>
      );
   }
};

export default DataTable;
